import axios from 'axios'
import {apiUrl} from './config'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const http = axios.create({
  baseURL: apiUrl,
  timeout: 30000,
  headers: {
  }
})

http.interceptors.request.use((config) => {

  /*
  const token = this.$cooperadowebapi.tokens.get()
  console.log("TESTE")
  console.log(token)

  if (token) {
    config.headers.Authorization=`Bearer ${token}`
  }*/

  return config
}, (err) => {
  return Promise.reject(err)
})


export default http;


// WEBPACK FOOTER //
// ./src/axios.js